import { useNavigate } from "react-router-dom";
import { logout } from "@safers/api";
import { useAuthStore } from "@safers/auth";
import { clearLastVisit } from "@/lib/lastVisit";
import { LOGIN_PATH } from "@/routes/paths";

export function useSignOut(): () => Promise<void> {
  const navigate = useNavigate();

  return async () => {
    const username = useAuthStore.getState().user?.username ?? null;
    await logout().catch(() => {});
    clearLastVisit(username);
    useAuthStore.getState().reset();
    navigate(LOGIN_PATH, { replace: true });
  };
}
